module.exports = __webpack_public_path__ + "roundabout.svg?d1071b2d76bb1b662d4bdca0963dc953";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/roundabout.svg
// module id = 215
// module chunks = 0